import { CapitalizeNames as capitalize } from 'src/utils/capitalize';
import { IMake } from 'src/interfaces/make';
import { TSelectItem } from '../components/types';
import { sortBy } from 'lodash';

/**
 * Maps the makes to a select item
 *
 * @param {IMake[]} makes
 * @return {*}  {TSelectItem[]}
 */
export const mapMakes = (makes: IMake[]): TSelectItem[] => {
    const makesMap = new Map<string, TSelectItem>();
    makes.forEach((make: IMake) => {
        makesMap.set(make._id, {
            value: make._id,
            label: capitalize(make.name),
        });
    });
    const sortedItems: TSelectItem[] = sortBy(
        Array.from(makesMap.values()),
        'label'
    );
    return sortedItems;
};
